class HHSizeGuide extends HTMLElement {
  constructor() {
    super()
    this.$guides = this.querySelectorAll('.js-size-guide-container')
    this.addEventListener('change', this.onGuideChange)
  }

  onGuideChange() {
    const guide_value = this.querySelector('.vp__input--dropdown input')?.value || ''
    if (guide_value !== '') {
      this.$guides.forEach(item => item.classList[item.dataset.guide === guide_value ? 'add': 'remove']('active'))
    }
  }
}

customElements.define('hh-size-guide', HHSizeGuide)
